import { ChangeUserPassword, IEditUserPayload, IUserCreate, IUserDocsUploadData, IUserListSearch, IUserLogin } from "../../../types/userInterface";
import api from "../../../lib/api";

export const loginRequestApi = async (data: IUserLogin) => {
  return await api.post(`/user/login`, data);
};

export const logoutRequestApi = async () => {
  return await api.delete(`/user/logout`);
};

export const createUserApi = async (data: IUserCreate) => {
  return await api.post(`/user`, data);
};

export const getUserListApi = async (data: IUserListSearch) => {
  return await api.get(`/user/${data.page}/${data.pageLimit}?search=${data?.search ?? ""}`);
};

export const changeUserStatusApi = async (id: number) => {
  return await api.put(`/user/update-status`, { userId: id });
};

export const getUserDataByIdApi = async (id: number) => {
  return await api.get(`/user/${id}`);
};

export const editUserDetailApi = async (payload: IEditUserPayload) => {
  return await api.put(`/user/${payload.id}`, payload.data);
};

export const getLoggedInUserDataApi = async () => {
  return await api.get(`/user/profile`);
};

export const changeUserPasswordApi = async (data: ChangeUserPassword) => {
  return await api.post(`/user/change-password/${data.userId}`, data.payload)
}
export const uploadUserDocsApi = async (data: FormData) => {
  return await api.post(`/user-documents`, data)
}

export const getUserDocLinkApi = (id : number) => {
  return api.get(`/user-documents/signed-url?id=${id}`);
};

export const deleteDocApi = (id : number) => {
  return api.delete(`user-documents/${id}`);
};

export const exportUserApi = (payload?: {
  search?: string;
}) => {
  return api.post("/user/export", payload ?? {}, {
    responseType: "blob",
  });
};
